import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';

import { API_URL } from '@/config/api';

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/settings`)
      .then(res => res.json())
      .then(data => setSettings(data))
      .catch(console.error);
  }, []);

  const logoUrl = settings?.logo_url || 'https://gc3h.co.za/wp-content/uploads/2022/02/gallagher-convention-centre-catering.png';

  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src={logoUrl} alt="GC3H" className="h-16 w-auto mb-6" />
            <p className="text-secondary-200 leading-relaxed max-w-md">
              GC3H is committed to providing the finest quality Halaal meals made from carefully sourced ingredients. 
              Our to-order catering solution makes it easy for venues, organisers and off-site premises to cater to special dietary requirements.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="https://www.facebook.com/GallagherConventionCentreHalaalCatering" target="_blank" rel="noopener noreferrer" 
                 className="text-secondary-200 hover:text-primary transition-colors">
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-primary">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-secondary-200 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/menu" className="text-secondary-200 hover:text-white transition-colors">Our Menu</Link>
              </li>
              <li>
                <Link to="/reviews" className="text-secondary-200 hover:text-white transition-colors">Reviews</Link>
              </li>
              <li>
                <Link to="/food-safety" className="text-secondary-200 hover:text-white transition-colors">Food Safety</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6 text-primary">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-secondary-200">{settings?.contact_address || '19 Richards Drive, Midrand Johannesburg, Gauteng'}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary flex-shrink-0" />
                <a href={`mailto:${settings?.contact_email || 'info@gc3h.co.za'}`} className="text-secondary-200 hover:text-white transition-colors">
                  {settings?.contact_email || 'info@gc3h.co.za'}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary flex-shrink-0" />
                <a href={`tel:${settings?.contact_phone || '011 266 3181'}`} className="text-secondary-200 hover:text-white transition-colors">
                  {settings?.contact_phone || '011 266 3181'}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-secondary-400 text-sm">
              &copy; {new Date().getFullYear()} GC3H - Gallagher Convention Centre Halaal Catering. All Rights Reserved.
            </p>
            <div className="flex space-x-6">
              <a href="https://gc3h.co.za/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="https://gc3h.co.za/terms-of-use/" target="_blank" rel="noopener noreferrer" className="text-secondary-400 hover:text-white text-sm transition-colors">
                Terms of Use
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
